import { GridColDef } from "@mui/x-data-grid";
import { t } from "i18next";
import DataGridApi from "../../../../components/dataGridApi";
import { ISpreadsheet } from "../../../../interfaces/ISpreadsheet";
import { CONFIG } from "../../../../services/config";

interface Props {
  spreadsheet?: ISpreadsheet;
}

export default function GarantiaEstentida({ spreadsheet }: Props) {
  const columns: GridColDef[] = [
    {
      field: "startWarrantyExtended",
      flex: 1,
      headerName: t("digitalServicePlan.startWarrantyExtended"),
      headerClassName: "header-style",
    },
    {
      field: "endWarrantyExtended",
      flex: 1,
      headerName: t("digitalServicePlan.endWarrantyExtended"),
      headerClassName: "header-style",
    },
    {
      field: "limitMonth",
      flex: 1,
      headerName: t("digitalServicePlan.limitMonth"),
      headerClassName: "header-style",
    },

    {
      field: "yearManufacture",
      flex: 1,
      headerName: t("digitalServicePlan.yearManufacture"),
      headerClassName: "header-style",
    },
    {
      field: "vin",
      flex: 2,
      headerName: t("digitalServicePlan.warrantyVin"),
      headerClassName: "header-style",
    },
    {
      field: "warrantyExtendedStatus",
      flex: 1,
      headerName: t("digitalServicePlan.warrantyExtendedStatus"),
      headerClassName: "header-style",
      renderCell({ row }: any) {
        return (
          <span>{`${t(
            `digitalServicePlan.${row.warrantyExtendedStatus}`,
          )}`}</span>
        );
      },
    },
    {
      field: "warrantyExtendedByProduct",
      flex: 2,
      headerName: t("digitalServicePlan.warrantyExtendedByProduct"),
      headerClassName: "header-style",
    },
  ];

  return (
    <DataGridApi
      params1="&param="
      labelParams1="Chassi"
      host={CONFIG.SOB_API}
      endPoint={`excel/warranty/${spreadsheet?.id}?`}
      columnsData={columns}
    />
  );
}
